import { cn } from "@/lib/utils";

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: "default" | "secondary" | "outline" | "destructive";
};

export function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium",
        variant === "default" && "bg-gray-900 text-white dark:bg-white dark:text-gray-900",
        variant === "secondary" && "bg-gray-100 text-gray-800 dark:bg-white/10 dark:text-gray-200",
        variant === "outline" && "border border-gray-300 text-gray-700 dark:border-white/20 dark:text-gray-300",
        variant === "destructive" && "bg-red-600 text-white",
        className,
      )}
      {...props}
    />
  );
}
